module.exports = __webpack_public_path__ + "img/ueberdachung.89c427c8.jpg";